import { IConfigsType } from '../../types'

const burgerworksDailySalesAndTransactions: IConfigsType = {
  burgerworks: {
    '/:brand/daily_sales_and_transactions': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'burgerworks/daily_sales_and_transactions',
        width: '3500px',
        height: '2500px',
      },
    },
  },
}

export default burgerworksDailySalesAndTransactions
